import axios from "axios";
import { useState, useEffect, use } from "react";
import Swal from "sweetalert2";
import { Pencil, Trash2, Plus, Search } from "lucide-react";

export default function Inventory() {
  const [search, setSearch] = useState("");

  //Suppliers Sections
  const [showSupplierModal, setShowSupplierModal] = useState(false);

  const [suppliername, setSuppliername] = useState("");
  const [mobilenumber, setMobilenumber] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [supplierslist, setSupplierlists] = useState([]);

  //Suppliers Sections
  const [showInventoryProductsModal, setInventoryProductsModal] =
    useState(false);

  const [productnameiv, setProductnameiv] = useState("");
  const [description, setDescription] = useState("");
  const [qty, setQty] = useState("");
  const [unit, setUnit] = useState("");
  const [unitprice, setUnitprice] = useState("");
  const [totalprice, setTotalprice] = useState("");
  const [gst, setGst] = useState("");
  const [inventoryproductslists, setInventoryproductlists] = useState([]);

  const [supplierid, setSupplierid] = useState("");

  const [isInventoryEdit, setIsInventoryEdit] = useState(false);
  const [inventoryEditId, setInventoryEditId] = useState(null);

  const [isSupplierEdit, setIsSupplierEdit] = useState(false);
  const [supplierEditId, setSupplierEditId] = useState(null);
  const [supplierTab, setSupplierTab] = useState("add");

  //Fetch Product
  useEffect(() => {
    fetchSuppliers();
    fetchInventoryproducts();
  }, []);

  //Fetch Suppliers
  const fetchSuppliers = () => {
    axios
      .get("http://tntyping.com/Adminconsole/api/nutssupplierslists")
      .then(function (response) {
        const result = response.data.result;
        const errorcode = response.data.errorCode;
        const message = response.data.Message;

        if (errorcode === 2) {
          Swal.fire({
            icon: "error",
            text: message,
            width: 320,
            padding: "1em",
            confirmButtonText: "OK",
            customClass: {
              popup: "rounded-xl text-sm"
            }
          });
        }
        if (errorcode === 0) {
          setSupplierlists(result);
        }
      });
  };

  //Fetch Inventory Products
  const fetchInventoryproducts = () => {
    axios
      .get("http://tntyping.com/Adminconsole/api/nutsinventoryproductslists")
      .then(function (response) {
        const result = response.data.result;
        const errorcode = response.data.errorCode;
        const message = response.data.Message;

        if (errorcode === 2) {
          Swal.fire({
            icon: "error",
            text: message,
            width: 320,
            padding: "1em",
            confirmButtonText: "OK",
            customClass: {
              popup: "rounded-xl text-sm"
            }
          });
        }
        if (errorcode === 0) {
          setInventoryproductlists(result);
        }
      });
  };

  const onDelete = (item) => {
    Swal.fire({
      text: "Do you want to delete?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6b7280",
      reverseButtons: true,
      width: 320,
      padding: "1em",
      customClass: {
        popup: "rounded-xl text-sm"
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            "http://tntyping.com/Adminconsole/api/deleteinventoryproductbyid?id=" +
              item.id
          );

          if (response.data.errorCode === 2) {
            Swal.fire({
              icon: "error",
              text: response.data.Message
            });
            return;
          }

          if (response.data.errorCode === 0) {
            Swal.fire({
              icon: "success",
              text: "Product Deleted Successfully",
              timer: 1500,
              showConfirmButton: false,
              width: 320,
              padding: "1em",
              confirmButtonText: "OK",
              customClass: {
                popup: "rounded-xl text-sm"
              }
            });

            fetchInventoryproducts();
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            text: "Something went wrong while deleting."
          });
        }
      }
    });
  };

  const formatDate = (date) => {
    if (!date) return "";

    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };

  //handleSupplierSubmit
  const handleSupplier = async () => {
    if (!suppliername) {
      Swal.fire({ icon: "error", text: "Please enter supplier name" });
      return;
    }

    if (!mobilenumber) {
      Swal.fire({ icon: "error", text: "Please enter mobile number" });
      return;
    }

    let url = "";

    if (isSupplierEdit) {
      console.log("Update URL:", url);
      url =
        "http://tntyping.com/Adminconsole/api/nutsupdatesuppliers" +
        "?id=" +
        supplierEditId +
        "&suppliername=" +
        encodeURIComponent(suppliername) +
        "&mobilenumber=" +
        mobilenumber +
        "&address=" +
        encodeURIComponent(address) +
        "&email=" +
        encodeURIComponent(email) +
        "&website=" +
        encodeURIComponent(website);
    } else {
      url =
        "http://tntyping.com/Adminconsole/api/nutscreatesuppliers" +
        "?suppliername=" +
        suppliername +
        "&mobilenumber=" +
        mobilenumber +
        "&address=" +
        address +
        "&email=" +
        email +
        "&website=" +
        website;
    }

    const response = await axios.post(url);

    if (response.data.errorCode === 0) {
      Swal.fire({
        icon: "success",
        text: isSupplierEdit
          ? "Supplier Updated Successfully"
          : "Supplier Added Successfully",
        timer: 1500,
        showConfirmButton: false
      });

      setShowSupplierModal(false);

      setSuppliername("");
      setMobilenumber("");
      setAddress("");
      setEmail("");
      setWebsite("");

      setIsSupplierEdit(false);
      setSupplierEditId(null);

      fetchSuppliers();
    } else {
      Swal.fire({
        icon: "error",
        text: response.data.Message
      });
    }
  };

  //hanleInventory
  const handleInventory = async () => {
    if (!supplierid) {
      Swal.fire({ icon: "error", text: "Please select supplier" });
      return;
    }

    if (!productnameiv) {
      Swal.fire({ icon: "error", text: "Please enter product name" });
      return;
    }

    if (!qty) {
      Swal.fire({ icon: "error", text: "Please enter qty" });
      return;
    }

    if (!unit) {
      Swal.fire({ icon: "error", text: "Please enter unit" });
      return;
    }

    if (!unitprice) {
      Swal.fire({ icon: "error", text: "Please enter unit price" });
      return;
    }

    if (!totalprice) {
      Swal.fire({ icon: "error", text: "Please enter total price" });
      return;
    }

    try {
      let response;

      if (isInventoryEdit) {
        // 🔥 UPDATE API
        response = await axios.post(
          "http://tntyping.com/Adminconsole/api/nutsupdateinventoryproducts" +
            "?id=" +
            inventoryEditId +
            "&supplierid=" +
            supplierid +
            "&productname=" +
            encodeURIComponent(productnameiv) +
            "&description=" +
            encodeURIComponent(description) +
            "&qty=" +
            qty +
            "&unit=" +
            encodeURIComponent(unit) +
            "&unitprice=" +
            unitprice +
            "&totalprice=" +
            totalprice +
            "&gst=" +
            gst
        );
      } else {
        // 🔥 CREATE API
        response = await axios.post(
          "http://tntyping.com/Adminconsole/api/nutscreateinventoryproducts" +
            "?supplierid=" +
            supplierid +
            "&productname=" +
            productnameiv +
            "&description=" +
            description +
            "&qty=" +
            qty +
            "&unit=" +
            unit +
            "&unitprice=" +
            unitprice +
            "&totalprice=" +
            totalprice +
            "&gst=" +
            gst
        );
      }

      if (response.data.errorCode === 2) {
        Swal.fire({ icon: "error", text: response.data.Message });
        return;
      }

      if (response.data.errorCode === 0) {
        Swal.fire({
          icon: "success",
          text: isInventoryEdit
            ? "Inventory Updated Successfully"
            : "Inventory Added Successfully",
          timer: 1500,
          showConfirmButton: false
        });

        setInventoryProductsModal(false);

        setSupplierid("");
        setProductnameiv("");
        setDescription("");
        setQty("");
        setUnit("");
        setUnitprice("");
        setTotalprice("");
        setGst("");

        setIsInventoryEdit(false);
        setInventoryEditId(null);

        fetchInventoryproducts();
      }
    } catch (error) {
      console.log("Update error:", error.response || error);

      Swal.fire({
        icon: "error",
        text: "Update failed. Check console."
      });
    }
  };

  //onInventoryEdit
  const onInventoryEdit = (item) => {
    setIsInventoryEdit(true);
    setInventoryEditId(item.id);

    setSupplierid(item.supplierid);
    setProductnameiv(item.productname);
    setDescription(item.description);
    setQty(item.qty);
    setUnit(item.unit);
    setUnitprice(item.unitprice);
    setTotalprice(item.totalprice);
    setGst(item.gst);

    setInventoryProductsModal(true);
  };

  //on Supplier Edit
  const onSupplierEdit = (item) => {
    setIsSupplierEdit(true);
    setSupplierEditId(item.id);

    setSuppliername(item.suppliername);
    setMobilenumber(item.mobilenumber);
    setAddress(item.address);
    setEmail(item.email);
    setWebsite(item.website);

    setSupplierTab("add"); // move here
    setShowSupplierModal(true);
  };

  //On Delete Supplier
  const onSupplierDelete = (item) => {
    Swal.fire({
      text: "Do you want to delete supplier?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await axios.post(
          "http://tntyping.com/Adminconsole/api/deletesuppliersbyid?id=" +
            item.id
        );

        if (response.data.errorCode === 0) {
          Swal.fire({
            icon: "success",
            text: "Supplier Deleted",
            timer: 1500,
            showConfirmButton: false,
            width: 320,
            padding: "1em",
            confirmButtonText: "OK",
            customClass: {
              popup: "rounded-xl text-sm"
            }
          });

          fetchSuppliers();
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.Message
          });
        }
      }
    });
  };

  return (
    <div className="p-6 space-y-6 bg-gray-50 min-h-screen">
      {/* ===== Header Section ===== */}
      <div className="flex items-center justify-between bg-white p-4 rounded-xl shadow-sm">
        {/* Left Section */}
        <div className="flex flex-col">
          <h2 className="text-xl font-semibold text-gray-800">Inventory</h2>
          <p className="text-xs text-gray-500">
            Manage inventory products and suppliers
          </p>
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-3">
          <button
            onClick={() => {
              setSuppliername("");
              setMobilenumber("");
              setAddress("");
              setEmail("");
              setWebsite("");
              setShowSupplierModal(true);
            }}
            className="flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm px-3 py-2 rounded-lg shadow-sm transition"
          >
            <Plus size={16} />
            Supplier
          </button>

          <button
            onClick={() => {
              setProductnameiv("");
              setDescription("");
              setQty("");
              setUnitprice("");
              setTotalprice("");
              setGst("");
              setInventoryProductsModal(true);
            }}
            className="flex items-center gap-1.5 bg-green-600 hover:bg-green-700 text-white text-sm px-3 py-2 rounded-lg shadow-sm transition"
          >
            <Plus size={16} />
            Product
          </button>
        </div>
      </div>

      {/* ===== Search + Info Bar ===== */}
      <div className="flex justify-between items-center">
        <div className="relative">
          <Search size={16} className="absolute left-3 top-3 text-gray-400" />
          <input
            type="text"
            placeholder="Search inventory..."
            className="pl-9 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white shadow-sm"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <span className="text-sm text-gray-500">
          Total: {inventoryproductslists.length} Inventory
        </span>
      </div>

      {/* ===== Table ===== */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider">
            <tr>
              <th className="p-4 text-left">Product</th>
              <th className="p-4 text-left">Supplier</th>
              <th className="p-4 text-left">Description</th>
              <th className="p-4 text-left">Qty</th>
              <th className="p-4 text-left">Unit</th>
              <th className="p-4 text-left">Unit Price</th>
              <th className="p-4 text-left">Total Price</th>
              <th className="p-4 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {inventoryproductslists.map((item) => (
              <tr
                key={item.id}
                className="border-t hover:bg-gray-50 transition"
              >
                <td className="p-4 font-medium text-gray-700">
                  {item.productname}
                </td>

                <td className="p-4 text-gray-600">
                  {supplierslist.find((sup) => sup.id == item.supplierid)
                    ?.suppliername || "-"}
                </td>

                <td className="p-4 text-gray-600">{item.description}</td>

                <td className="p-4 text-gray-600">{item.qty}</td>

                <td className="p-4 text-gray-600">{item.unit}</td>

                <td className="p-4 text-gray-600">{item.unitprice}</td>

                <td className="p-4 text-gray-600">{(item.qty) * (item.unitprice)}</td>

                <td className="p-4 flex justify-center gap-4">
                  <button
                    className="text-blue-600 hover:text-blue-800 transition"
                    onClick={() => onInventoryEdit(item)}
                  >
                    <Pencil size={18} />
                  </button>

                  <button
                    className="text-red-500 hover:text-red-700 transition"
                    onClick={() => onDelete(item)}
                  >
                    <Trash2 size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* ===== Pagination Footer ===== */}
        <div className="flex justify-between items-center p-4 border-t bg-gray-50">
          <span className="text-sm text-gray-500">
            Showing 1 to {inventoryproductslists.length} of{" "}
            {inventoryproductslists.length} entries
          </span>

          <div className="flex gap-2">
            <button className="px-3 py-1 border rounded-md text-sm hover:bg-gray-100">
              Previous
            </button>
            <button className="px-3 py-1 bg-blue-600 text-white rounded-md text-sm">
              1
            </button>
            <button className="px-3 py-1 border rounded-md text-sm hover:bg-gray-100">
              Next
            </button>
          </div>
        </div>
      </div>

      {/* ===== Show Supplier Modal ====== */}
      {showSupplierModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-2xl w-[600px] space-y-4 shadow-xl">
            {/* Header */}
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-semibold text-gray-800">
                Supplier Management
              </h3>

              <button
                onClick={() => setShowSupplierModal(false)}
                className="text-gray-500 hover:text-black"
              >
                ✕
              </button>
            </div>

            {/* Tabs */}
            <div className="flex gap-4 border-b pb-2">
              <button
                onClick={() => setSupplierTab("add")}
                className={`px-3 py-1 rounded ${
                  supplierTab === "add"
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200"
                }`}
              >
                Add Supplier
              </button>

              <button
                onClick={() => setSupplierTab("list")}
                className={`px-3 py-1 rounded ${
                  supplierTab === "list"
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200"
                }`}
              >
                View Suppliers
              </button>
            </div>

            {/* ADD SUPPLIER FORM */}
            {supplierTab === "add" && (
              <div className="space-y-3">
                <input
                  placeholder="Supplier Name *"
                  className="border w-full px-3 py-2 rounded-lg"
                  value={suppliername}
                  onChange={(e) => setSuppliername(e.target.value)}
                />

                <input
                  placeholder="Mobile Number *"
                  className="border w-full px-3 py-2 rounded-lg"
                  value={mobilenumber}
                  onChange={(e) => setMobilenumber(e.target.value)}
                />

                <input
                  placeholder="Address"
                  className="border w-full px-3 py-2 rounded-lg"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />

                <input
                  placeholder="Email"
                  className="border w-full px-3 py-2 rounded-lg"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                <input
                  placeholder="Website"
                  className="border w-full px-3 py-2 rounded-lg"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                />

                <div className="flex justify-end gap-3 pt-2">
                  <button
                    onClick={() => setShowSupplierModal(false)}
                    className="px-4 py-2 text-gray-600 hover:text-black"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={handleSupplier}
                    className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg"
                  >
                    {isSupplierEdit ? "Update" : "Save"}
                  </button>
                </div>
              </div>
            )}

            {/* SUPPLIER LIST */}
            {supplierTab === "list" && (
              <div className="max-h-80 overflow-y-auto">
                <table className="w-full text-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="p-2 text-left">Name</th>
                      <th className="p-2 text-left">Mobile</th>
                      <th className="p-2 text-left">Email</th>
                      <th className="p-2 text-center">Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {supplierslist.map((item) => (
                      <tr key={item.id} className="border-t">
                        <td className="p-2">{item.suppliername}</td>
                        <td className="p-2">{item.mobilenumber}</td>
                        <td className="p-2">{item.email}</td>

                        <td className="p-2 flex justify-center gap-3">
                          <button
                            className="text-blue-600"
                            onClick={() => {
                              onSupplierEdit(item);
                              setSupplierTab("add");
                            }}
                          >
                            <Pencil size={18} />
                          </button>

                          <button
                            className="text-red-600"
                            onClick={() => onSupplierDelete(item)}
                          >
                            <Trash2 size={18} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ===== Show Inventory Product Modal ====== */}
      {showInventoryProductsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-2xl w-96 space-y-4 shadow-xl">
            <h3 className="text-lg font-semibold text-gray-800">
              Add Inventory Products
            </h3>

            <select
              value={supplierid}
              onChange={(e) => setSupplierid(e.target.value)}
              className="border border-gray-300 rounded-lg w-full px-2 py-1.5 mt-1 text-sm focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Supplier</option>
              {supplierslist.map((item, index) => (
                <option key={item.id} value={item.id}>
                  {item.suppliername}
                </option>
              ))}
            </select>

            <input
              placeholder="Product Name *"
              className="border w-full px-3 py-2 rounded-lg"
              value={productnameiv}
              onChange={(e) => setProductnameiv(e.target.value)}
            />

            <input
              placeholder="Description"
              className="border w-full px-3 py-2 rounded-lg"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />

            <input
              placeholder="Qty *"
              className="border w-full px-3 py-2 rounded-lg"
              value={qty}
              onChange={(e) => setQty(e.target.value)}
            />

            <input
              placeholder="Unit *"
              className="border w-full px-3 py-2 rounded-lg"
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
            />

            <input
              placeholder="Unit Price *"
              className="border w-full px-3 py-2 rounded-lg"
              value={unitprice}
              onChange={(e) => setUnitprice(e.target.value)}
            />

            <input
              placeholder="Total Price *"
              className="border w-full px-3 py-2 rounded-lg"
              value={totalprice}
              onChange={(e) => setTotalprice(e.target.value)}
            />

            <input
              placeholder="GST"
              className="border w-full px-3 py-2 rounded-lg"
              value={gst}
              onChange={(e) => setGst(e.target.value)}
            />

            <div className="flex justify-end gap-3 pt-2">
              <button
                onClick={() => setInventoryProductsModal(false)}
                className="px-4 py-2 text-gray-600 hover:text-black"
              >
                Cancel
              </button>

              <button
                onClick={handleInventory}
                className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
